import React from "react";
import clsx from "clsx"
import { ICON_CONSTANTS } from "../../../constants/ImageConstants.js"
import DatePicker from "react-datepicker"
import { useTranslation } from "react-i18next"

export default function YearPicker({ year, setYear, filterDate = () => true }) {
  const { t } = useTranslation()
  const CustomInput = React.forwardRef(({ value, className, onClick }, ref) => (
    <div
      ref={ref}
      onClick={onClick}
      className={clsx([
        className,
        "select-date d-flex justify-content-between align-items-center cursor-pointer"
      ])}>
      <span>{value}</span>
      <img src={ICON_CONSTANTS.CALENDER_INPUT} alt="caledar" />
    </div>
  ))
  return (
    <div className={""}>
      <div className={"custom-year-picker"}>
        <DatePicker
          renderCustomHeader={({ decreaseYear, increaseYear }) => (
            <div className="d-flex justify-content-between align-items-center px-5">
              <span className={"font-weight-bolder"} style={{ fontSize: "16px" }}>
                {t("label_select_year")}
              </span>
              <div className={"d-flex align-items-center"}>
                <img className={"mr-4"} src={ICON_CONSTANTS.ARROW_LEFT_DARK} onClick={decreaseYear} />
                <img src={ICON_CONSTANTS.ARROW_RIGHT_DARK} onClick={increaseYear} />
              </div>
            </div>
          )}
          popperClassName={"year-picker-popper"}
          selected={year}
          onChange={(date) => setYear(date)}
          showYearPicker={true}
          dateFormat={"yyyy"}
          filterDate={filterDate}
          customInput={<CustomInput />}
          inline={false}
        />
      </div>
    </div>
  )
}